module.exports = __webpack_public_path__ + "img/sending_3.210730ff.png";